import { ArsTableGroupCalculationDto } from "../interface";
import { isArsTableOperation, isArsTableSubGroupGroupingFactor } from "../typeguards";

/**
 * Recursively search through table groups, and return the group(s) that contain the specified id.
 *
 * @param tableGroups - Source groups
 * @param id - Grouping factor id/Operation id to search for
 * @param isT - Type guard function for the generic type T used in the subgroup label
 * @returns Array of groups that contain the specified id
 */
export const findTableGroupsWithId = <T = string>(
  tableGroups: ArsTableGroupCalculationDto<T>[],
  id: string,
  isT: (value: unknown) => value is T,
): ArsTableGroupCalculationDto<T>[] => {
  const ret: ArsTableGroupCalculationDto<T>[] = [];
  for (const group of tableGroups) {
    if (isArsTableSubGroupGroupingFactor(group, isT) && group.groupingFactor?.id === id) {
      ret.push(group);
    } else if (isArsTableOperation(group, isT) && group.operation?.id === id) {
      ret.push(group);
    }
    if (group.subGroups && group.subGroups.length > 0) {
      ret.push(...findTableGroupsWithId(group.subGroups, id, isT));
    }
  }
  return ret;
};
